<article class="ci-loader-section w-full h-screen fixed top-0 bottom-0 right-0 left-0 bg-black-alpha-60">
  <section class="w-full h-full flex flex-column justify-content-center align-items-center">
    <span class="ci-loader"></span>
    
    <div class="ci-loader-text text-lg ci-txt--white mt-3 font-light flex gap-1">
      <span class="ci-loader-letter">C</span>
      <span class="ci-loader-letter">a</span>
      <span class="ci-loader-letter">r</span>
      <span class="ci-loader-letter">g</span>
      <span class="ci-loader-letter">a</span>
      <span class="ci-loader-letter">n</span>
      <span class="ci-loader-letter">d</span>
      <span class="ci-loader-letter">o</span>
    </div>
  </section>
<article>
